<header class="h-14 bg-white dark:bg-[#151c2b] border-b border-slate-200 dark:border-slate-800 flex items-center justify-between px-6 shrink-0">
  <!-- Left: Breadcrumbs -->
  <div class="flex items-center gap-2 text-[13px]">
    <a (click)="navigateToDashboard()" class="text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 transition-colors cursor-pointer">
      <span class="material-symbols-outlined text-[18px]">home</span>
    </a>
    @for (crumb of breadcrumbs(); track crumb.title) {
      <span class="text-slate-300 dark:text-slate-600 select-none">/</span>
      @if (crumb.url) {
        <a (click)="navigateBreadcrumb(crumb.url)"
           class="text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 cursor-pointer transition-colors">
          {{ crumb.title }}
        </a>
      } @else {
        <span class="text-slate-800 dark:text-white font-semibold">{{ crumb.title }}</span>
      }
    }
  </div>

  <!-- Right: Actions -->
  <div class="flex items-center gap-1">
    <!-- Custom header nodes (notifications, etc.) rendered as icon buttons -->
    @for (node of customNodes; track node.Id) {
      <button (click)="node.Children?.length > 0 ? openChildrenNodes(node) : topMenuItemClick(node)"
              class="size-9 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors relative">
        <span class="material-symbols-outlined text-[20px]">{{ mapCustomIcon(node.Icon) }}</span>
        @if (hasNotificationDot(node.Icon)) {
          <span class="absolute top-1.5 right-1.5 flex h-2 w-2 rounded-full bg-red-500"></span>
        }
        <!-- Children dropdown -->
        @if (childrenNodes[node.Id]?.Show && node.Children?.length > 0) {
          <div class="absolute right-0 top-10 bg-white dark:bg-[#1a2233] border border-slate-200 dark:border-slate-700 rounded-xl shadow-lg py-1 min-w-[200px] z-50">
            @for (child of node.Children; track child.Id) {
              <button (click)="topMenuItemClick(child); $event.stopPropagation()"
                      class="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors text-left">
                {{ translationsService.translate(child.OriginalTitle) }}
              </button>
            }
          </div>
        }
      </button>
    }

    @if (showPlatformIcon) {
      <button (click)="navigateToPlatform()"
              class="size-9 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
        <span class="material-symbols-outlined text-[20px]">apps</span>
      </button>
    }

    <!-- Divider -->
    <div class="w-px h-6 bg-slate-200 dark:bg-slate-700 mx-2"></div>

    <!-- User -->
    <button (click)="userMenuClick()"
            class="flex items-center gap-2.5 px-2 py-1.5 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors relative">
      <div class="size-8 rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400 flex items-center justify-center text-xs font-bold">
        {{ initials }}
      </div>
      @if (!showOnlyUser) {
        <div class="text-left">
          <p class="text-[13px] font-medium text-slate-900 dark:text-white leading-tight">{{ username }}</p>
          @if (loginName) {
            <p class="text-[10px] text-slate-500 dark:text-slate-400">{{ loginName }}</p>
          }
        </div>
        <span class="material-symbols-outlined text-slate-400 text-[18px]">expand_more</span>
      }
      @if (showOnlyUser) {
        <p class="text-[13px] font-medium text-slate-900 dark:text-white">{{ username }}</p>
        <span class="material-symbols-outlined text-slate-400 text-[18px]">expand_more</span>
      }

      <!-- User dropdown menu -->
      @if (userMenuState) {
        <div class="absolute right-0 top-12 bg-white dark:bg-[#1a2233] border border-slate-200 dark:border-slate-700 rounded-xl shadow-lg py-1 min-w-[200px] z-50"
             (click)="$event.stopPropagation()">
          <!-- Daily Challenges 
          <button (click)="openDailyChallengeDialog()"
                  class="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors text-left">
            <span class="material-symbols-outlined text-[18px]">emoji_events</span>
            Dnevni izzivi
            <span class="dc-header-xp-badge">1/3 🔥</span>
          </button>-->
          <!-- Profile -->
          <button (click)="userPopupClick()"
                  class="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors text-left">
            <span class="material-symbols-outlined text-[18px]">person</span>
            {{ translationsService.translate('WebGalis_ProfilePage') }}
          </button>
          <!-- Manual / instructions (PDF) - shown only when environment.instructionsUrl is set -->
          @if (instructionsUrl) {
            <button (click)="openInstructions()"
                    class="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors text-left">
              <span class="material-symbols-outlined text-[18px]">help</span>
              Navodila
            </button>
          }
          <!-- Dynamic user menu items -->
          @for (node of userMenuResult; track node.Id) {
            <button (click)="topMenuItemClick(node)"
                    class="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors text-left">
              {{ translationsService.translate(node.OriginalTitle) }}
            </button>
          }
          <!-- Version -->
          <div class="border-t border-slate-100 dark:border-slate-700 mt-1 pt-1 px-4 py-2">
            <p class="text-[11px] text-slate-400">{{ translationsService.translate('Version') }}: {{ version }}</p>
          </div>
        </div>
      }
    </button>

    <!-- Language picker -->
    @if (!showOnlyUser) {
      <button (click)="languageMenuClick()"
              class="flex items-center gap-1 px-2.5 py-1.5 rounded-lg text-[13px] font-medium text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors relative">
        <span class="material-symbols-outlined text-[16px]">language</span>
        {{ currentLanguage }}
        <span class="material-symbols-outlined text-[14px]">expand_more</span>

        @if (languageMenuState) {
          <div class="absolute right-0 top-10 bg-white dark:bg-[#1a2233] border border-slate-200 dark:border-slate-700 rounded-xl shadow-lg py-1 min-w-[140px] z-50"
               (click)="$event.stopPropagation()">
            @for (node of languageMenuResult; track node.Id) {
              <button (click)="languageChange(node.Title)"
                      class="w-full flex items-center gap-3 px-4 py-2.5 text-[13px] text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors text-left">
                {{ translationsService.translate(node.OriginalTitle) }}
              </button>
            }
          </div>
        }
      </button>
    }

    <!-- Form action response values -->
    @for (node of formActionResponses; track node) {
      <span class="text-[12px] font-medium text-slate-600 dark:text-slate-400 px-2">{{ node }}</span>
    }
  </div>
</header>
